import { projectDetailActions } from '@core/actions/project-detail.actions';
import _ from 'lodash-es';
import { createReducer, on } from '@ngrx/store';
import { RequestStatus } from '@core/signal-store-features/request-state.feature';

export interface ProjectIndexUiState {
  requestStatus: RequestStatus;
  keywordsCount: IKeywordCount;
  initialLoad: boolean;
  error: string | null;
}

export interface IKeywordCount {
  [keyword: string]: number;
}

export const PROJECT_FILTERS_FORM_ID = 'Project Filters';

export const initialProjectIndexUIState: ProjectIndexUiState = {
  requestStatus: RequestStatus.idle,
  initialLoad: false,
  keywordsCount: {},
  error: null,
};

export const projectIndexUIReducer = createReducer(
  initialProjectIndexUIState,
  on(projectDetailActions.loadProjectListings, (state, props) => ({
    ...state,
    requestStatus: RequestStatus.pending,
    error: null,
  })),
  on(projectDetailActions.projectListingsLoaded, (state, props) => ({
    ...state,
    requestStatus: RequestStatus.success,
    initialLoad: true,
    error: null,
  })),
  on(projectDetailActions.keywordsLoaded, (state, props) => ({
    ...state,
    keywordsCount: props.keywordCount,
  })),
  on(projectDetailActions.projectListingsLoadFailed, (state, props) => ({
    ...state,
    requestStatus: RequestStatus.error,
    error: props.error,
  }))
);
